import { faBell, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { useSelector } from '@redux';
import { Button, Col, Divider, Row, Space } from 'antd';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditInfoModal from '../components/Modal/EditInfoModal';
import { ORDER_TTB_CANCEL_REASONS } from 'constants/ordersTabTryBuy';

const OtherInformation = ({ data }) => {
  const { t } = useTranslation();
  // const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  const [formType, setFormType] = useState('');

  return (
    <>
      <EditInfoModal formType={formType} onCancel={() => setFormType('')} />
      {data?.deliveryType !== 'INTERNAL' && (
        <>
          <Space size={10} className="align-items-start">
            {data?.deliveryNote && (
              <FontAwesomeIcon icon={faBell} className="mt-[5px]" />
            )}
            <div>
              <Space size={20}>
                <div className="fw-600">{t('orders.deliveryNote')}</div>
                <Button
                  type="text"
                  icon={<FontAwesomeIcon icon={faPenToSquare} />}
                  className="action-btn"
                  onClick={() => setFormType('deliveryNote')}
                />
              </Space>
              {data?.deliveryNote ? (
                <div>{data?.deliveryNote}</div>
              ) : (
                <div className="color-dark-gray fw-400 opacity-40 italic">
                  {t('orders.empty.deliveryNote')}
                </div>
              )}
            </div>
          </Space>
          <Divider className="my-[10px]" />
        </>
      )}
      <Space size={10} className="align-items-start">
        {data?.note && <FontAwesomeIcon icon={faBell} className="mt-[5px]" />}
        <div>
          <Space size={20}>
            <div className="fw-600">{t('orders.note')}</div>
            <Button
              type="text"
              icon={<FontAwesomeIcon icon={faPenToSquare} />}
              className="action-btn"
              onClick={() => setFormType('note')}
            />
          </Space>
          {data?.note ? (
            <div>{data?.note}</div>
          ) : (
            <div className="color-dark-gray fw-400 opacity-40 italic">
              {t('orders.empty.note')}
            </div>
          )}
        </div>
      </Space>
      <Divider className="my-[10px]" />
      <Space size={10} className="align-items-start invoice-section">
        {!isEmpty(data?.invoiceInfo) && (
          <FontAwesomeIcon icon={faBell} className="mt-[5px]" />
        )}
        <div>
          <Space size={20}>
            <div className="fw-600">{t('orders.invoiceInformation')}</div>
            {data?.statusOms === 'AWAITING_CONFIRMATION' ? (
              <Button
                type="text"
                icon={<FontAwesomeIcon icon={faPenToSquare} />}
                className="action-btn"
                onClick={() => setFormType('invoiceInfo')}
              />
            ) : (
              <div />
            )}
          </Space>
          {data?.invoiceInfo?.email ||
          data?.invoiceInfo?.taxCode ||
          data?.invoiceInfo?.telephone ? (
            <Row gutter={20}>
              <Col span={8}>
                <div className="fw-500">{t('invoiceInfo.businessName')}</div>
              </Col>
              <Col span={16}>
                <div>{data?.invoiceInfo?.businessName || ''}</div>
              </Col>
              <Col span={8}>
                <div className="fw-500">{t('invoiceInfo.address')}</div>
              </Col>
              <Col span={16}>
                <div>{data?.invoiceInfo?.address || ''}</div>
              </Col>
              <Col span={8}>
                <div className="fw-500">{t('invoiceInfo.taxCode')}</div>
              </Col>
              <Col span={16}>
                <div>{data?.invoiceInfo?.taxCode || ''}</div>
              </Col>
              <Col span={8}>
                <div className="fw-500">{t('invoiceInfo.telephone')}</div>
              </Col>
              <Col span={16}>
                <div>{`${data?.invoiceInfo?.telephone || ''}`}</div>
              </Col>
              <Col span={8}>
                <div className="fw-500">{t('invoiceInfo.email')}</div>
              </Col>
              <Col span={16}>
                <div>{`${data?.invoiceInfo?.email || ''}`}</div>
              </Col>
            </Row>
          ) : (
            <div className="color-dark-gray fw-400 opacity-40 italic">
              {t('orders.empty.invoiceInformation')}
            </div>
          )}
        </div>
      </Space>
      {(data?.statusOms === 'CANCELLED' || data?.cancelReason) && (
        <>
          <Divider className="my-[10px]" />
          <div className="fw-600">{t('orderDetail.cancelledReason')}</div>
          <div>
            {data?.cancelReason &&
              t(
                ORDER_TTB_CANCEL_REASONS.find(
                  (e) => e.value === data?.cancelReason,
                )?.text,
              )}
          </div>
          <div className="color-dark-gray fw-400 opacity-40 italic">
            {data?.cancelNote || ''}
          </div>
        </>
      )}
    </>
  );
};

export default OtherInformation;
